import React, { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Input } from "@/components/ui/kit";
import { formatGs } from "@/lib/format";
import { Check, X, Ban } from "lucide-react";

export const VoidBadge = ({ sale }) => {
  if (sale.status === "anulada") return <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-destructive text-white" data-testid={`sale-status-${sale.id}`}>ANULADA</span>;
  if (sale.void_status === "pendiente") return <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-amber-500 text-black" data-testid={`sale-status-${sale.id}`}>ANULACIÓN PENDIENTE</span>;
  if (sale.void_status === "rechazada") return <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-secondary border border-border" data-testid={`sale-status-${sale.id}`}>ANULACIÓN RECHAZADA</span>;
  return null;
};

export const VoidDecisionButtons = ({ saleId, onDone }) => {
  const [busy, setBusy] = useState(false);
  const decide = async (approve) => {
    const note = approve ? "" : (window.prompt("Motivo del rechazo (opcional):") ?? null);
    if (note === null) return;
    setBusy(true);
    try {
      await api.post(`/sales/${saleId}/void-decision`, { approve, note });
      toast.success(approve ? "Anulación aprobada: stock y caja ajustados" : "Anulación rechazada");
      onDone?.();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex gap-1.5">
      <button disabled={busy} onClick={() => decide(true)} data-testid={`void-approve-${saleId}`} className="px-2 py-1 rounded-md bg-emerald-500/15 text-emerald-500 text-[11px] font-semibold flex items-center gap-1 hover:bg-emerald-500/25 disabled:opacity-50"><Check className="w-3 h-3" /> Aprobar</button>
      <button disabled={busy} onClick={() => decide(false)} data-testid={`void-reject-${saleId}`} className="px-2 py-1 rounded-md bg-destructive/15 text-destructive text-[11px] font-semibold flex items-center gap-1 hover:bg-destructive/25 disabled:opacity-50"><X className="w-3 h-3" /> Rechazar</button>
    </div>
  );
};

export const QUICK_REASONS = ["Cobro duplicado", "Producto equivocado", "Cantidad equivocada", "Método de pago equivocado", "Cliente canceló el pedido"];

export const VoidRequestButton = ({ sale, onDone }) => {
  const [open, setOpen] = useState(false);
  const [other, setOther] = useState("");
  const [busy, setBusy] = useState(false);
  if (sale.status === "anulada" || sale.void_status === "pendiente") return null;
  const send = async (reason) => {
    if (!reason?.trim() || busy) return;
    setBusy(true);
    try {
      await api.post(`/sales/${sale.id}/void-request`, { reason: reason.trim() });
      toast.success("Solicitud de anulación enviada al administrador");
      setOpen(false); setOther("");
      onDone?.();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} title="Solicitar anulación" data-testid={`void-request-${sale.id}`} className="text-muted-foreground hover:text-destructive"><Ban className="w-4 h-4" /></button>
      <Modal open={open} onClose={() => setOpen(false)} title="Solicitar anulación">
        <div className="space-y-3" data-testid="void-reason-modal">
          <p className="text-xs text-muted-foreground">Venta #{sale.id.slice(0, 8).toUpperCase()} · {formatGs(sale.total)}. Tocá el motivo y se envía al administrador.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {QUICK_REASONS.map((r, i) => (
              <button key={r} disabled={busy} onClick={() => send(r)} data-testid={`void-reason-${i}`}
                className="h-11 px-3 rounded-lg border border-border text-sm font-semibold text-left hover:border-destructive hover:bg-destructive/10 transition-colors disabled:opacity-50">{r}</button>
            ))}
          </div>
          <div className="flex gap-2">
            <Input value={other} onChange={(e) => setOther(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send(other)} placeholder="Otro motivo…" data-testid="void-reason-other" />
            <Btn onClick={() => send(other)} disabled={busy || !other.trim()} data-testid="void-reason-send">Enviar</Btn>
          </div>
        </div>
      </Modal>
    </>
  );
};
